/*
 * Date: 2025
 * Description: All reusable constants
 * Author: Philippe Leroux @ skitsc
 */

//Interfaces
import { i_complete_list, i_list, i_makes, i_models, i_order_payments, i_payments, i_question, i_runs, i_select, i_settings, i_user_orders } from "../interfaces/items.interface";
import { i_alert, i_filter, i_pagination, i_script_entry, i_script_errors } from "../interfaces/utility.interface";
import { i_user, i_user_address, i_user_login } from "../interfaces/user.interface";
import { t_run, t_socket_event } from "../types/types";
import { generateTimenow } from "./utility";

const default_search : i_filter = {
    make_id : '',
    model_id : '',
    year : '',
    sku : '',
    order : 'DESC',
    page : 1,
    rows_per_page : 10,
    disabled: 0,
    search: 'initial',
}

const default_make : i_makes = {
    _id : '',
    name : '',
    initial : true,
}
const default_model : i_models = {
    _id : '',
    name : '',
    make_id : '',
    years : [],
    initial : true,

}
const default_alert : i_alert = {
    open : false,
    severity : 'info',
    message : ''
}
const default_list : i_list = {
    _id : '',
    name : '',
    description : '',
    notes : [],
    user_id : '',
    items: [],
    admin_selected : false,
    selected : false,
    timestamp : 0,
    status : 'initial',
    po : '',
    comment : '',
    payments : [],
    order_number: '',
    disabled: false,
}
const defaultCompleteList : i_complete_list = { ...default_list , history : []}
const default_run : i_runs = {
    _id: '',
    index: 0,
    event: 'default',
    timestamp: 0,
    finish_timestamp: 0,
}
const defaultAddress : i_user_address = {
    unitNumber: '',
    doorNumber: '',
    street: '',
    city: '',
    state: 'QC',
    country: 'Canada',
    postalCode: '',
}
const default_user : i_user = {
    _id : '',
    username : '',
    businessName : '',
    accountNumber : '',
    email : '',
    password : '',
    type : 'user',
    active : 0,
    creditLimit : 4000,
    phone : '',
    address : defaultAddress,
    lastLogin : 0,
    timestamp : 0,
}
const defaultUserOrder : i_user_orders = {
    user : default_user,
    list : [],
}

const defaultLoginUser : i_user_login = {
    username : '',
    password : '',
    email : '',
    note : '',
    ip : '',
    session_uuid : '',
    otp : '',
    phone : '',
    user_agent : '',
    timestamp : 0,
}

const lexique = {
    str_regex: /^[^\\/&\[\]{}<>]*$/,
    str_regex_min: /^[^\\/&@.,(){}<>]{5,}$/,
    password_regex:/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/,
    email_regex:/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    alpha_regex: /^[A-Za-z0-9]+$/i,
    alpha_error: "Please use only alphanumeric caracters",
    special_error: "cannot contain special characters.",
    email_error: "email should match email patern ex : example@example.com",
    numeric_error: "only accepts numeric values ex : 0 , 12",
    empty_error: "Please provide a value to ",
    password_error: "must have between 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character!",
};
const lexiqueMessage = {
    empty_error: "Please fill in the field.",
    str_error: "Please do not use special characters like []|{}<>",
    alpha_error: "Please use only alphanumeric characters.",
    special_error: "can only contain special characters.",
    email_error: "The email must match the email format, e.g., example@example.com.",
    password_error: "must be between 8 and 15 characters long, including at least one lowercase letter, one uppercase letter, one digit, and one special character!",
    user_type_error : "Please provide a valid user type",
};

const eventsArr : t_run[] = [ 'atpac', 'lkq', 'tiger','moneydex', 'rockauto' , 'partsavatar'];

const emptyScript : i_script_entry = {
    pid : 0,
    state : 'paused',
    type : 'default',
    count : 0,
    timestamp : 0,
    data : [],
}

const emptyScriptErrors : i_script_errors = {
    type : '',
    state : '',
    count : '',
    pid : '',
    timestamp : '',
}
const defaultSettings : i_settings = {
    email : '',
    perPrice : 0,
    flatPrice : 0,
    mailConfig : {
        host : '',
        secure : false,
        username : '',
        password : '',
        from : '',
        pool : false
    },
    vendors: [],
    active : true,
    timestamp : 0,
}
const defaultQuestion : i_question = {
    _id : '',
    subject : '',
    message : '',
    user_id : '',
    timestamp : 0,
    read : false,
}

const defaultPayment : i_payments = {
    amount : '',
    type : '',
    note : '',
    path : [],
    timestamp : 0,
    date : generateTimenow(),
}

const defaultOrderPayments : i_order_payments = {
    _id : '',
    index : -1,
    payment : defaultPayment,
}
const provinces : i_select[] = [{ value : "QC"} , { value : "MB"} , { value : "ON" } , { value : " BC"} , { value : "NB"},{ value : "AB"} , { value : "LB"}]
const country : i_select[] = [{ value : "Canada" }, { value : "United States" }]
const socketEventTypes : t_socket_event[] = ['Add' , 'Update' , 'Info' , 'Delete']
export { default_search, default_make , default_model , default_alert , defaultUserOrder, default_list , defaultCompleteList, default_user , defaultLoginUser , lexique , provinces , country,
     lexiqueMessage , eventsArr , emptyScript , emptyScriptErrors , default_run , defaultSettings , defaultQuestion , defaultOrderPayments , defaultPayment , socketEventTypes };